import { render, staticRenderFns } from "./ForceReadOpenAccount.vue?vue&type=template&id=72be3634&scoped=true"
import script from "./ForceReadOpenAccount.vue?vue&type=script&lang=js"
export * from "./ForceReadOpenAccount.vue?vue&type=script&lang=js"
import style0 from "./ForceReadOpenAccount.vue?vue&type=style&index=0&id=72be3634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be3634",
  null
  
)

export default component.exports